import { TDeviceType } from '@cian/ui-kit';

export enum EPageType {
  Career = 'career',
  CareerVacancies = 'careerVacancies',
  CareerVacancy = 'careerVacancy',
  Listing = 'listing',
  Card = 'card',
}

export interface IPageState {
  type: EPageType;
  deviceType: TDeviceType;
}
